import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  BoxProps,
  Divider,
  Grow,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

interface Props extends BoxProps {
  isOpen?: boolean;
  title: string;
  onClose?: () => void;
}

export const ContainedModal: React.FC<Props> = ({
  isOpen,
  title,
  onClose,
  children,
  sx,
  ...props
}) => {
  return (
    <Grow in={isOpen}>
      <Box
        {...props}
        sx={{
          flex: 1,
          position: 'absolute',
          top: 1,
          left: '-8px',
          width: 'calc(100% + 16px)',
          // height: '100%',
          // backgroundColor: '#FFFFFF',
          // boxShadow: 24,
          zIndex: 1000,
          ...sx,
        }}
      >
        <Stack
          direction="column"
          sx={{
            boxShadow: 24,
            mb: 8,
            pb: 4,
            flex: 1,
            display: 'flex',
            backgroundColor: '#FFFFFF',
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            pl={6}
            pr={2}
            py={1}
          >
            <Typography fontWeight="400" fontSize="18px" lineHeight="28px">
              {title}
            </Typography>

            <Tooltip title="Fechar">
              <IconButton
                onClick={onClose}
                sx={{
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Stack>

          <Divider />

          <Box mb={2} mr={2} pl={3} mt={2}>
            {children}
          </Box>
        </Stack>
      </Box>
    </Grow>
  );
};
